// Copyright (C) 2019 TANNER AG

export const SET_PURCHASE_PRICE = "SET_PURCHASE_PRICE";
export const SET_RESIDUAL_VALUE = "SET_RESIDUAL_VALUE";
export const SET_DRIVING_PROFILE = "SET_DRIVING_PROFILE";
export const SET_EFFICIENT_HYBRID = "SET_EFFICIENT_HYBRID";
export const SET_FUEL_PRICE = "SET_FUEL_PRICE";
export const SET_HOLDING_PERIOD = "SET_HOLDING_PERIOD";
export const SET_ANNUAL_MILEAGE = "SET_ANNUAL_MILEAGE";
export const ADD_BUS = "ADD_BUS";
export const SET_CONFIGURATION = "SET_CONFIGURATION";
export const RESET = "RESET";



// WEBPACK FOOTER //
// ./src/tco/store/actions.js